import { render, staticRenderFns } from "./vsc-input.vue?vue&type=template&id=27c41db0&scoped=true&"
import script from "./vsc-input.vue?vue&type=script&lang=ts&"
export * from "./vsc-input.vue?vue&type=script&lang=ts&"
import style0 from "./vsc-input.vue?vue&type=style&index=0&id=27c41db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c41db0",
  null
  
)

export default component.exports